import React from 'react'

import { AnimatedTextFallback } from '../animatedFallbacks'
import { StyledTitleAndLinkWrapper } from './styles'

const CarouselHeaderFallback = () => {
  return (
    <StyledTitleAndLinkWrapper>
      <AnimatedTextFallback level={2} />
    </StyledTitleAndLinkWrapper>
  )
}

export { CarouselHeaderFallback }
